module.exports = __webpack_public_path__ + "img/pin-sensor.8fa354dd.svg";